<template>
    <div><h1>LAporan</h1></div>
</template>
